import LoadMask from "Utils/LoadMask/LoadMask";
import CrearEditarForm from "./CrearEditarForm";
import React, { Component } from "react";
import { api } from "api";

class CrearEditar extends Component {
    state = {
        edit: false,
        loader: true,
        id: null,
        recursos: [],
        tiposPermiso: [],
        asuetosGuatemala: [],
    };

    async componentDidMount() {
        this.props.obtenerJefes()
        try {
            const recursos = await api.get("recurso/filter_list");
            let tiposPermiso = await api.get("tipo_permiso/filter_list");
            tiposPermiso = tiposPermiso.filter((p) => p.id !== 1);
            const asuetosGuatemala = await api.get("asueto/get_events", {
                pais_nombre: "Guatemala",
            });
            this.setState({ recursos, tiposPermiso, asuetosGuatemala });
        } catch (e) {}
        this.setState({ loader: false });
        const edit = this.props.match.params.id ? true : false;
        this.setState({ edit });
        if (edit == true) {
            const id = this.props.match.params.id;
            this.setState({ id });
            this.props.obtenerPermiso(id);
        }
    }

    onSubmit = (data) => {
        const { edit, id } = this.state;
        const { onSubmit, actualizarPermiso } = this.props;
        if (edit) {
            actualizarPermiso(data, id);
        } else {
            onSubmit(data);
        }
    };

    render() {
        const { loader, jefes, jefesLoader } = this.props;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <h2 className="title--blue">
                            {this.state.edit ? "EDITAR" : "CREAR"} PERMISO
                        </h2>
                    </div>
                </div>
                <hr />
                <div className="login-wrapper">
                    <div className="card card-login w-100">
                        <LoadMask loading={ jefesLoader || loader || this.state.loader} light>
                            <CrearEditarForm
                                onSubmit={this.onSubmit}
                                recursos={this.state.recursos}
                                tiposPermiso={this.state.tiposPermiso}
                                edit={this.state.edit}
                                asuetosGuatemala={this.state.asuetosGuatemala}
                                jefes={jefes}
                            />
                        </LoadMask>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CrearEditar;
